import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLister } from '../../actions/lister-actions';
import TRANSLATIONS from '../../translations/translations@default.json';

const Breadcrumb = ({ breadcrumb }) => {
	const dispatch = useDispatch();

	const { sorting } = useSelector((state) => state);

	if (breadcrumb && Array.isArray(breadcrumb)) {
		return (
			<div className="list-none">
				<a
					href="/"
					className="mr-2 text-cta-action"
					data-tag-name="breadcrumb-clicked"
					data-tag-category="Home">
					{TRANSLATIONS.breadcrumbs.home}
				</a>

				<span className="mr-2 font-regular text-tertiary">/</span>

				{breadcrumb.map(function ({ Title, Href }, index, arr) {
					Href += sorting?.CurrentSortBy
						? '?sort=' + sorting?.CurrentSortBy
						: '';

					if (index === arr.length - 1) {
						return (
							<span
								aria-current={Title}
								tabIndex="-1"
								key={`breadcrumb-${Title}`}
								data-tag-name="breadcrumb-clicked"
								data-tag-category={Title}
								data-testid="last-breadcrumb"
								href="#clicked"
								className="font-regular text-secondary">
								{Title}
							</span>
						);
					}

					return (
						<React.Fragment key={`breadcrumb-${Title}`}>
							<a
								href={Href}
								data-tag-name="breadcrumb-clicked"
								data-tag-category={Title}
								data-testid={`breadcrumbLink${index}`}
								onClick={(e) => {
									e.preventDefault();
									dispatch(
										getLister(Href, {
											type: '',
											trackHistory: true,
										})
									);
								}}
								className="mr-2 text-cta-action">
								{Title}
							</a>
							<span className="mr-2 font-regular text-tertiary">/</span>
						</React.Fragment>
					);
				})}
			</div>
		);
	}

	return null;
};

export default Breadcrumb;
